import {
  defineCborSchema,
  CborField,
  type CborSchema,
} from '@mesh/friendly-cbor-serializer'
import { type ResponseHeader, ResponseHeaderSchema } from '../responseHeader'
import {
  type CheckMeshfaStatusResponsePayload,
  CheckMeshfaStatusResponsePayloadSchema,
} from './responsePayload'

export type CheckMeshfaStatusResponse = {
  header: ResponseHeader
  payload?: CheckMeshfaStatusResponsePayload
}

export const CheckMeshfaStatusResponseSchema: CborSchema<CheckMeshfaStatusResponse> =
  defineCborSchema<CheckMeshfaStatusResponse>({
    header: CborField({ key: 0, type: ResponseHeaderSchema }),
    payload: CborField({
      key: 1,
      required: false,
      type: CheckMeshfaStatusResponsePayloadSchema,
    }),
  })
